import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesCompras() {
  const { user } = useContext(AuthContext);
  return (
    <>
          <Header />
          {user.menu_ventas ?(
      <div className="container">
        <br />
        <br />
        <Row >
        <Col md={4} align="center">
              {user.grupos ? (
                <Button
                  href="/DepartamentosClientes"
                  className="botonesMenu"
                  color="success"
                >
                  <i class="fas fa-store fa-7x"></i>
                  <br />
                  <br />
                  Departamentos
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-store fa-7x"></i>
                  <br />
                  <br />
                  Departamentos
                </Button>
              )}
            </Col>
        <Col md={4} align="center">
              {user.grupos ? (
                <Button
                  href="/Grupos"
                  className="botonesMenu"
                  color="success"
                >
                  <i class="fas fa-users fa-7x"></i>
                  <br />
                  <br />
                  Grupos
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-users fa-7x"></i>
                  <br />
                  <br />
                  Grupos
                </Button>
              )}
            </Col>
        <Col md={4} align="center">
              {user.menu_clientes ? (
                <Button
                  href="/Clientes"
                  className="botonesMenu"
                  color="success"
                >
                  <i class="fas fa-user-tie fa-7x"></i>
                  <br />
                  <br />
                  Clientes
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-user-tie fa-7x"></i>
                  <br />
                  <br />
                  Clientes
                </Button>
              )}
            </Col>
            </Row>
          <br />
          <Row>
            <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/VentaDirectaCreate" className="botonesMenu" color="success">
              <i class="fas fa-receipt fa-7x"></i>
              <br />
              <br />
              Venta Directa
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-receipt fa-7x"></i>
          <br />
          <br />
          Venta Directa
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/VentaDirectaArchivoCreate" className="botonesMenu" color="success">
              <i class="fas fa-receipt fa-7x"></i>
              <br />
              <br />
              Venta Directa <br /> Archivo
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-receipt fa-7x"></i>
          <br />
          <br />
          Venta Directa <br /> Archivo
        </Button> }
          </Col>
        <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/ListadoPedidos" className="botonesMenu" color="success">
              <i class="fas fa-shopping-basket fa-7x"></i>
              <br />
              <br />
              Pedidos
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-shopping-basket fa-7x"></i>
          <br />
          <br />
          Pedidos
        </Button> }
          </Col>

          </Row>
          <br />
          <Row>
      

          <Col md={4} align="center">
          {user.surtidos_create ?(
            <Button href="/ListadoPendienteSurtir" className="botonesMenu" color="success">
              <i class="fas fa-truck-moving fa-7x"></i>
              <br />
              <br />
              Surtir
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-truck-moving fa-7x"></i>
          <br />
          <br />
          Surtir
        </Button> }
          </Col>
          
          <Col md={4} align="center">
          {user.menu_surtidos ?(
            <Button href="/ListadoSurtidos" className="botonesMenu" color="success">
              <i class="fas fa-file-invoice-dollar fa-7x"></i>
              <br />
              <br />
              Notas
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-file-invoice-dollar fa-7x"></i>
          <br />
          <br />
          Notas
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_devoluciones ?(
            <Button href="/ListadoDevoluciones" className="botonesMenu" color="success">
              <i class="fas fa-undo-alt fa-7x"></i>
              <br />
              <br />
              Devoluciones
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-undo-alt fa-7x"></i>
          <br />
          <br />
          Devoluciones
        </Button> }
          </Col>

        
        {/* <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/AnalisisArticulosPedidos" className="botonesMenu" color="success">
              <i class="fas fa-search fa-7x"></i>
              <br />
              <br />
              Analisis Pedidos
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-search fa-7x"></i>
          <br />
          <br />
          Analisis Pedidos
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_pedidos ?(
            <Button href="/ListadoPedidosCliente" className="botonesMenu" color="success">
              <i class="fas fa-shopping-basket fa-7x"></i>
              <br />
              <br />
              Pedidos <br /> Cliente
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-shopping-basket fa-7x"></i>
          <br />
          <br />
          Pedidos <br /> Cliente
        </Button> }
          </Col> */}

        </Row>
        <br />
        <Row>
        <Col md={4} align="center">
            {user.menu_pedidos ?(
              <Button
                href="/ReporteVentasArticulo"
                className="botonesMenu"
                color="success"
              >
                <i class="fa-solid fa-chart-gantt fa-7x"></i>
                <br />
                <br />
                Reporte Ventas <br /> Articulo
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
                <i class="fa-solid fa-chart-gantt fa-7x"></i>
            <br />
            <br />
            Reporte Ventas <br /> Articulo
          </Button> }
            </Col>

            {/* <Col md={4} align="center">
            {user.menu_pedidos ?(
              <Button
                href="/ReporteVentasArticuloAgrupado"
                className="botonesMenu"
                color="success"
              >
                <i class="fa-solid fa-chart-bar fa-7x"></i>
                <br />
                <br />
                Reporte Ventas <br /> Articulo Agrupado
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i class="fa-solid fa-chart-bar fa-7x"></i>
            <br />
            <br />
            Reporte Ventas <br /> Articulo Agrupado
          </Button> }
            </Col> */}

            <Col md={4} align="center">
            {user.menu_pedidos ?(
              <Button
                href="/ReporteVentasArticuloMP"
                className="botonesMenu"
                color="success"
              >
                <i class="fa-solid fa-chart-line fa-7x"></i>
                <br />
                <br />
                Reporte Ventas <br /> Diario
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i class="fa-solid fa-chart-line fa-7x"></i>
            <br />
            <br />
            Reporte Ventas <br /> Diario
          </Button> }
            </Col>

            <Col md={4} align="center">
            {user.menu_pedidos ?(
              <Button
                href="/ReporteMasterCostos"
                className="botonesMenu"
                color="success"
              >
                <i class="fa-solid fa-dollar-sign fa-7x"></i>
                <br />
                <br />
                Master Costos
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i class="fa-solid fa-dollar-sign fa-7x"></i>
            <br />
            <br />
            Master Costos
          </Button> }
            </Col>

        </Row>
        <br />
        <Row>
        <Col md={4} align="center">
            {user.menu_pedidos ?(
              <Button
                href="/ReporteUltimoPrecio"
                className="botonesMenu"
                color="success"
              >
                <i class="fas fa-dollar-sign fa-7x"></i>
                <br />
                <br />
                Ultimo Precio Cliente
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i class="fas fa-dollar-sign fa-7x"></i>
            <br />
            <br />
            Ultimo Precio Cliente
          </Button> }
            </Col>

            <Col md={4} align="center">
            {user.menu_pedidos ?(
              <Button
                href="/ReporteUltimoPrecioArticulo"
                className="botonesMenu"
                color="success"
              >
                <i class="fas fa-tshirt fa-7x"></i>
                <br />
                <br />
                Ultimo Precio Articulo
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i class="fas fa-tshirt fa-7x"></i>
            <br />
            <br />
            Ultimo Precio Articulo
          </Button> }
            </Col>
            <Col md={4} align="center">
            {user.menu_pedidos ?(
              <Button
                href="/Paqueterias"
                className="botonesMenu"
                color="success"
              >
                <i class="fas fa-luggage-cart fa-7x"></i>
                <br />
                <br />
                Paqueterias
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i class="fas fa-luggage-cart fa-7x"></i>
            <br />
            <br />
            Paqueterias
          </Button> }
            </Col>
        </Row>
        {/* <br />
        <Row>
           <Col md={4} align="center">
            {user.menu_pedidos ?(
              <Button
                href="/ReporteVentasArticuloMPAgrupado"
                className="botonesMenu"
                color="success"
              >
                <i class="fa-solid fa-chart-column fa-7x"></i>
                <br />
                <br />
                Reporte Ventas <br /> Articulos MP Agrupado
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i class="fa-solid fa-chart-column fa-7x"></i>
            <br />
            <br />
            Reporte Ventas <br /> Articulos MP Agrupado
          </Button> }
            </Col>
            <Col md={4} align="center">
            {user.menu_pedidos ?(
              <Button
                href="/AnalisisGeneralProductos"
                className="botonesMenu"
                color="success"
              >
                <i class="fa-solid fa-magnifying-glass-chart fa-7x"></i>
                <br />
                <br />
                Analisis General <br /> Productos
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
                <i class="fa-solid fa-magnifying-glass-chart fa-7x"></i>
            <br />
            <br />
            Analisis General <br /> Productos
          </Button> }
            </Col>
        </Row> */}
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesCompras;
